const guiColors = {
    'motion-primary': 'hsla(48, 100%, 61%, 1)',
    'motion-primary-transparent': 'hsla(48, 100%, 61%, 0.9)',
    'motion-tertiary': 'hsla(48, 100%, 45%, 1)',

    'looks-secondary': 'hsla(48, 100%, 61%, 1)',
    'looks-transparent': 'hsla(48, 100%, 61%, 0.35)',
    'looks-light-transparent': 'hsla(48, 100%, 61%, 0.15)',
    'looks-secondary-dark': 'hsla(48, 100%, 45%, 1)'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
